import React from 'react';
import Slider from 'react-slick';
import { Carousels, CarouselType, CarouselTypes } from './config';
import styles from '../../AppCollectionCarousel/styles.module.scss';
import { Paper } from '@material-ui/core';
import i18n from 'i18next';
import { AppCollectionHeader } from '../../AppCollectionCarousel/app-collection-header';
import ctx from 'classnames';

export interface carouselWrapperConfig {
  carouselKey?: CarouselType;
  collectionDisplayName?: string;
  carousalName?: string;
  collectionId?: string;
  wrapInPaper?: boolean;
  hideSeeAll?: boolean;
  slidesToShow?: number;
  initialSlide?: number;
  noHeader?: boolean;
  heading?: boolean;
  developerName?: string;
  noTopPadding?: boolean;
}

type ComponentProps = {
  carouselWrapperConfig: carouselWrapperConfig;
};

export const CarouselWrapper: React.FC<ComponentProps> = ({
  children,
  carouselWrapperConfig,
}): JSX.Element => {
  const localeUSA = i18n.language === 'en-US';
  let {
    carouselKey,
    collectionDisplayName,
    carousalName,
    collectionId,
    wrapInPaper,
    hideSeeAll,
    noHeader,
    slidesToShow,
    initialSlide,
    noTopPadding,
  } = carouselWrapperConfig;
  carouselKey = carouselKey || CarouselTypes.Tile;
  let config = Carousels[carouselKey];
  if (slidesToShow) config.slidesToShow = slidesToShow;
  if (initialSlide) config.initialSlide = initialSlide;

  return (
    <div className={ctx(styles.heroWrapper, noTopPadding ? styles.noTopPadding : null)}>
      {!noHeader && (
        <AppCollectionHeader
          collectionDisplayName={collectionDisplayName}
          carousalName={carousalName}
          collectionId={collectionId}
          localeUSA={localeUSA}
          hideSeeAll={!!hideSeeAll}
        />
      )}
      {wrapInPaper ? (
        <Paper>
          <Slider {...config}>{children}</Slider>
        </Paper>
      ) : (
        <Slider {...config}>{children}</Slider>
      )}
    </div>
  );
};
